import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PSF_COMBO_SIGNATURE_COUNT_EXPERIMENT = defineFcm('psf_combo_signature_count_experiment')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experimentName: { type: 'string' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-koi',
		scope: 'corgi-front-end',
		context: 'psf combo (promote-or-share) page',
		description: `Gates the signature-count-instead-of-promoter-count experiment on the combo screen
			- experimentName: experiment service name (dynamic so ops can swap iterations without a deploy)`,
		import: false,
		template: {
			experimentName: 'psf_combo_signature_count_experiment',
		},
		deprecated: 'FCM no longer in use (CHANGE-97045) — front-end usage removed',
	});
